import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  pressed(event) {
    const action = event.target.dataset.value
    const elPlanName = document.querySelector(".plan-name");
    // Example:
    if (action === "1") {
      elPlanName.textContent = "do Plano Basic"
    } else if (action === "2") {
      elPlanName.textContent = "do Plano Standard"
    } else if (action === "3") {
      elPlanName.textContent = "do Plano Premium"
    }
  }
}
